import axios from 'axios'
import config from './config'

export default axios.create({
  baseURL: config.API_URL,
  headers: {
    api_key: '4590C926-E5F7-4EA3-A28F-76B3F175B555',
  },
})
